<template>
    <div>
        <template v-if="!isEdit">
            <template v-if="filter == 'decimal'"><span :title="text">{{ text | decimalFormat }}</span></template> 
            <template v-else-if="filter == 'image'"><img :src="urlify(text)" :alt="text" :title="text" style="width:100%;word-wrap: break-word;" v-if="urlify(text)" @click="isShow = true"><preview-image v-if="isShow" @close="isShow = false"><img :src="urlify(text)" slot="body" :alt="text" v-if="text" style="width: 100%"></preview-image></template> 
            <template v-else><span :title="text" style="word-wrap: break-word;">{{text}}</span></template> 
            <template v-if="filter != 'image'">
                <a href="javascript:void(0);" class="small" @click="isEdit = true"><span class="glyphicon glyphicon-pencil"></span></a>
            </template>
        </template>
        <template v-else>
            <template v-if="type == 'textarea'">
                <textarea rows="3" v-model="text" class="form-control" style="resize: vertical"></textarea>
                <div class="text-right" style="padding-top:5px;"><a href="javascript:void(0);" class="btn btn-default" @click="saveChange"> OK </a></div>
            </template>
            <template v-else-if="type == 'image'">
                <!-- <img :src="text" :alt="text" :title="text"> -->
            </template>
            <template v-else>
                <input type="text" v-model="text" class="form-control">
                <div class="text-right" style="padding-top:5px;"><a href="javascript:void(0);" class="btn btn-default" @click="saveChange"> OK </a></div>
            </template>
        </template>
    </div>
</template>

<script>
import PreviewImage from '@/components/elements/PreviewImage'
    export default {
        props: ['value','type','filter'],
        data: function(){
            return {
                text: this.value,
                isEdit: false,
                isShow: false
            }
        },
        components: {
            PreviewImage
        },
        methods: {
            saveChange: function(){
                this.isEdit = false
                this.$emit('input',this.text)
                this.$emit('edited')
            },
            urlify: function(text) {
                var urlRegex = /(https?:\/\/[^\s]+)/g;
                if (text.match(urlRegex) && text.match(urlRegex).length > 0) {
                    return text.match(urlRegex)[0]
                }
                return null
            }
        },
        watch: {
            'value' : function(newVal, oldVal) {
                if (newVal != oldVal) {
                    this.text = this.value
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/elements/Editable.vue